module.exports = __webpack_public_path__ + "img/report-de.99ce9dd7.png";